export default __webpack_public_path__ + "static/media/Logo_blanco.e73b0914.svg";